var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":"https://www.youtube.com/embed/zpOULjyy-n8?rel=0","allowfullscreen":""}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"mb-4"},[_c('strong',[_vm._v("Default Usage")])])
}]

export { render, staticRenderFns }